export default __webpack_public_path__ + "static/media/logo-monibrand.03ce0b79.png";